export default class SearchResult {
  constructor(entity, organizationId, conversationId, metadata) {
    this.id = `searchResult:${organizationId}:${entity.id}`
    this.entity = entity
    this.entityId = entity.id
    this.entityType = entity.$entityType
    this.metadata = metadata
    this.organizationId = organizationId
    this.conversationId = conversationId
  }

  static is(o) { return o instanceof this }
}
